import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { DURATA, VISTA } from "../utils/motionPresets";

const faqKeys = [
  "elevator",
  "parking",
  "dogs",
  "smoking",
  "onlineCheckin",
  "selfCheckin",
  "checkInOut",
  "station",
  "breakfast",
  "cancellation",
  "wifi",
];

// Due colonne su desktop: la lista in fila era lunghissima.
function dividiInDue(voci) {
  const meta = Math.ceil(voci.length / 2);
  return [voci.slice(0, meta), voci.slice(meta)];
}

function Voce({ chiave, aperta, onToggle, t }) {
  return (
    <div className="border-b border-[#2e2921]">
      <button
        onClick={onToggle}
        aria-expanded={aperta}
        className="w-full flex items-start justify-between gap-4 py-5 text-left group"
      >
        <span
          className={`cormorant text-[19px] leading-snug transition-colors duration-200 ${
            aperta
              ? "text-lux-accent font-semibold"
              : "text-lux-cream font-medium group-hover:text-lux-accent"
          }`}
        >
          {t(`faq.items.${chiave}.q`)}
        </span>
        <motion.span
          animate={{ rotate: aperta ? 45 : 0 }}
          transition={{ duration: 0.2 }}
          className="mt-0.5 flex-shrink-0 text-lux-accent text-xl leading-none"
          aria-hidden="true"
        >
          +
        </motion.span>
      </button>

      <AnimatePresence initial={false}>
        {aperta && (
          <motion.div
            key="risposta"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <p className="pb-5 pr-8 text-lux-cream/70 text-sm leading-relaxed">
              {t(`faq.items.${chiave}.a`)}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const { t } = useTranslation();
  const [aperta, setAperta] = useState(null);

  const toggle = (k) => setAperta(aperta === k ? null : k);
  const [colonnaSx, colonnaDx] = dividiInDue(faqKeys);

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: DURATA.blocco, ease: "easeOut" }}
      viewport={VISTA}
      className="py-14 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-lux-accent text-xs font-bold tracking-[0.25em] uppercase mb-3">
            {t("faq.subtitle")}
          </p>
          <h2 className="text-3xl font-medium tracking-wide text-lux-cream">{t("faq.title")}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14">
          <div className="border-t border-[#2e2921]">
            {colonnaSx.map((k) => (
              <Voce
                key={k}
                chiave={k}
                aperta={aperta === k}
                onToggle={() => toggle(k)}
                t={t}
              />
            ))}
          </div>
          <div className="border-t border-[#2e2921] md:mt-0 -mt-px">
            {colonnaDx.map((k) => (
              <Voce
                key={k}
                chiave={k}
                aperta={aperta === k}
                onToggle={() => toggle(k)}
                t={t}
              />
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <h3 className="text-2xl font-medium tracking-wide text-lux-cream mb-3">
            {t("faq.cta.headline")}
          </h3>
          <p className="text-lux-cream/70 mb-7">{t("faq.cta.sub")}</p>
          <a
            href="/camere"
            className="inline-block bg-lux-accent-strong hover:bg-lux-highlight text-[#161310] font-semibold uppercase tracking-widest text-xs py-4 px-12 rounded-sm border border-lux-accent hover:border-lux-highlight transition-colors duration-300"
          >
            {t("faq.cta.button")}
          </a>
        </div>
      </div>
    </motion.section>
  );
}
